export const ARYA_SHAKTI_NUMBER = "ARYA_SHAKTI_NUMBER";
